const normalizePathWithTrailingSlash = (value, fallback = "/") => {
  let normalized = String(value || fallback).trim();
  if (!normalized) normalized = fallback;
  if (!normalized.startsWith("/")) normalized = `/${normalized}`;
  normalized = normalized.replace(/\/+$/, "");
  if (!normalized) return "/";
  return `${normalized}/`;
};

export const resolveAuthUrl = (configuredUrl, fallbackPath = "/") => {
  const override = String(configuredUrl || "").trim();
  if (override) return override;

  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const normalizedPath = normalizePathWithTrailingSlash(fallbackPath, "/");
  return origin ? `${origin}${normalizedPath}` : normalizedPath;
};
